import { GTKSekolahFilter } from "./Interfaces/GTKSekolahInterface";
import { FilterSekolah, FilterSekolahPage } from "./Interfaces/SekolahInterfaces";
import { FilterKomisi } from "./Interfaces/KomisiInterface";
import { FilterMpkMpkw } from "./Interfaces/MpkMpkwInterfaces";
import { FilterPengurus } from "./Interfaces/PengurusInterfaces";
import { FilterProgramKerja } from "./Interfaces/ProgramKerjaInterface";
import { FilterStrukturOrganisasi } from "./Interfaces/StrukturOrganisasi";
import { FilterTaskForce } from "./Interfaces/TaskForceInterface";
import { FilterGTK } from "./Interfaces/GTKInterfaces";
import { FilterYayasan } from "./Interfaces/YayasanInterfaces";
import { FilterTrainerPage } from "./Interfaces/TrainerInterfaces";
import { FilterManajemenRolePage, FilterRoleList, FilterRolePermissionPage } from "./Interfaces/ManajemenRoleInterface";
import { FilterMitra } from "./Interfaces/MitraInterface"
import { FilterValidasiPembayaranIuran } from "./Interfaces/ValidasiPembayaranIuranInterfaces";
import dayjs from "dayjs";
import { FilterLowonganPekerjaan } from "./Interfaces/LowonganPekerjaanInterfaces";
import { FilterPelamarPekerjaan } from "./Interfaces/PelamarPekerjaanInterfaces";
import { FilterBeasiswa } from "./Interfaces/BeasiswaInterfaces";
import { FilterPelamarBeasiswa } from "./Interfaces/PelamarBeasiswaInterfaces";
import { ManajemenAlumniFkipFilterForm } from "./Interfaces/ManajemenAlumniFkipInterface";
import { FilterLaporan } from "./Interfaces/LaporanInterfaces";
import { GetManajemenCalonGuruListRequest } from "./Interfaces/ManajemenCalonGuruInterface";

// Request will be proxied via /api/be/[...apiGateway].ts
const baseUrl = "/api/be";

export const BackendApiUrl = {
    test: baseUrl + "/api/test",
    lowonganPekerjaan: {
        getProvinsi: baseUrl + '/api/lowongan-pekerjaan/get-provinsi',
        getKabupatenKotaByProvinsiKode: baseUrl + '/api/lowongan-pekerjaan/get-kabupaten-kota',
        getTipeLowonganPekerjaan: baseUrl + '/api/lowongan-pekerjaan/get-tipe-lowongan-pekerjaan',
        getMataPelajaran: baseUrl + '/api/lowongan-pekerjaan/get-mata-pelajaran',
        getRentangGaji: baseUrl + '/api/lowongan-pekerjaan/get-rentang-gaji',
        getStatusLowonganPekerjaan: baseUrl + '/api/lowongan-pekerjaan/get-status-lowongan-pekerjaan',
        getLowonganPekerjaanById: baseUrl + '/api/lowongan-pekerjaan/get-lowongan-pekerjaan-by-id',
        getKategoriLowonganPekerjaan: `${baseUrl}/api/lowongan-pekerjaan/get-kategori-lowongan-pekerjaan`,
        getLowonganPekerjaanPaginate: baseUrl + '/api/lowongan-pekerjaan/get-lowongan-pekerjaan-paginate',
        deleteKualifikasi: baseUrl + '/api/lowongan-pekerjaan/delete-kualifikasi',
        saveLowonganPekerjaan: baseUrl + '/api/lowongan-pekerjaan/save-lowongan-pekerjaan',
        deleteLowonganPekerjaan: baseUrl + '/api/lowongan-pekerjaan/delete-lowongan-pekerjaan',
        exportExcelLowonganPekerjaan: baseUrl + '/api/lowongan-pekerjaan/export-excel-lowongan-pekerjaan',
    },
    pelamarPekerjaan: {
        getPelamarPekerjaanPaginate: baseUrl + '/api/pelamar-pekerjaan/get-pelamar-pekerjaan-paginate',
        getPelamarPekerjaanById: baseUrl + '/api/pelamar-pekerjaan/get-pelamar-pekerjaan-by-id',
        updateStatus: baseUrl + '/api/pelamar-pekerjaan/update-status',
        updateStatusToInitialScreening: baseUrl + '/api/pelamar-pekerjaan/update-status-to-initial-screening',
        getStatusPelamar: baseUrl + '/api/pelamar-pekerjaan/get-status-pelamar',
        getWawancaraStatusUpOption: baseUrl + '/api/pelamar-pekerjaan/get-wawancara-status-up',
        exportExcelPelamarPekerjaan: baseUrl + '/api/pelamar-pekerjaan/export-excel-pelamar-pekerjaan',
        getProvinsi: baseUrl + '/api/pelamar-pekerjaan/get-provinsi',
        getKabupatenKota: baseUrl + '/api/pelamar-pekerjaan/get-kabupaten-kota',
        getJenjangPendidikan: baseUrl + '/api/pelamar-pekerjaan/get-jenjang-pendidikan',
    },
    beasiswa: {
        list: baseUrl + '/api/beasiswa/list',
        getBeasiswaById: baseUrl + '/api/beasiswa/get-beasiswa-by-id',
        save: baseUrl + '/api/beasiswa/save',
        delete: baseUrl + '/api/beasiswa/delete',
        deleteBenefit: baseUrl + '/api/beasiswa/delete-benefit',
        deleteSyarat: baseUrl + '/api/beasiswa/delete-syarat',
        exportExcel: baseUrl + '/api/beasiswa/export-excel',
        getJenisBeasiswa: baseUrl + '/api/beasiswa/get-jenis-beasiswa',
        getKategoriBeasiswa: baseUrl + '/api/beasiswa/get-kategori-beasiswa',
        getKategoriPemberiBeasiswa: baseUrl + '/api/beasiswa/get-kategori-pemberi-beasiswa',
        getMitraByUser: baseUrl + '/api/beasiswa/get-mitra-by-user',
    },
    pelamarBeasiswa: {
        getPelamarBeasiswaPaginate: baseUrl + '/api/pelamar-beasiswa/get-pelamar-beasiswa-paginate',
        getPelamarBeasiswaById: baseUrl + '/api/pelamar-beasiswa/get-pelamar-beasiswa-by-id',
        updateStatus: baseUrl + '/api/pelamar-beasiswa/update-status',
        updateStatusToInitialScreening: baseUrl + '/api/pelamar-beasiswa/update-status-to-initial-screening',
        getStatusPendaftarBeasiswa: baseUrl + '/api/pelamar-beasiswa/get-status-pendaftar-beasiswa',
        getWawancaraStatusUpOption: baseUrl + '/api/pelamar-beasiswa/get-wawancara-status-up',
        getJenjangPendidikan: baseUrl + '/api/pelamar-beasiswa/get-jenjang-pendidikan',
        exportExcel: baseUrl + '/api/pelamar-beasiswa/export-excel',
    },
    access: {
        saveFirstTimeAccess: baseUrl + '/api/Access/save-access-first-time',
        getUserHasUnverifiedRole: baseUrl + '/api/Access/get-user-has-unverified-user-roles',
    },
    AppSetting: {
        saveKodeEtik: baseUrl + "/api/app-settings/save-kode-etik",
        getKodeEtik: baseUrl + '/api/app-settings/get-kode-etik',
        saveSkGuki: baseUrl + "/api/app-settings/save-sk-guki",
        getSkGuki: baseUrl + '/api/app-settings/get-sk-guki',
    },
    dashboard: {
        getDashboardCounts: baseUrl + '/api/dashboard/count',
    },
    blob: {
        presignedPutObject: baseUrl + '/api/v1/blob/presigned-put-object',
        presignedGetObject: baseUrl + '/api/v1/blob/presigned-get-object',
        download: baseUrl + '/api/v1/blob/download',
    },
    crawling: {
        syncDataDapodik: baseUrl + '/api/v1/crawling/sync-data-dapodik',
        syncStatus: baseUrl + '/api/v1/crawling/get-sync-status',
        checkDapodikByNPYP: baseUrl + '/api/v1/crawling/check-verval-by-npyp',
        crawlYayasanByNPYP: baseUrl + '/api/v1/crawling/crawl-yayasan',
        syncSekolahByNPSN: baseUrl + '/api/v1/crawling/sync-sekolah',
    },
    yayasan: {
        getMemberYayasanPaginate: baseUrl + '/api/yayasan/get-member-yayasan-paginate',
        getYayasanPaginate: baseUrl + '/api/yayasan/get-yayasan-paginate',
        getSekolahByYayasanIdPaginate: baseUrl + '/api/yayasan/get-sekolah-by-yayasanId-paginate',
        getYayasanById: baseUrl + '/api/yayasan/get-yayasan-by-id',
        getYayasanByNPYP: baseUrl + '/api/yayasan/get-yayasan-by-npyp',
        getProvinsi: baseUrl + '/api/yayasan/get-provinsi',
        getAllKabupatenKota: baseUrl + '/api/yayasan/get-all-kabupaten-kota',
        getAllKecamatan: baseUrl + '/api/yayasan/get-all-kecamatan',
        getAllKelurahan: baseUrl + '/api/yayasan/get-all-kelurahan',
        getKabupatenKotaByProvinsiKode: baseUrl + '/api/yayasan/get-kabupaten-kota-by-provinsi-kode',
        getKabupatenKotaByListProvinsiKode: baseUrl + '/api/yayasan/get-kabupaten-kota-by-list-provinsi-kode',
        getKecamatanByKabupatenKotaKode: baseUrl + '/api/yayasan/get-kecamatan-by-kabupaten-kota-kode',
        getKelurahanByKecamatanKode: baseUrl + '/api/yayasan/get-kelurahan-by-kecamatan-kode',
        getStatusKepemilikan: baseUrl + '/api/yayasan/get-status-kepemilikan',
        getAllMPKMPKW: baseUrl + '/api/yayasan/get-all-mpk-mpkw',
        getAllStatusApprovalKeanggotaanYayasan: baseUrl + '/api/yayasan/get-all-status-approval-keanggotaan-yayasan',
        approveYayasan: baseUrl + '/api/yayasan/approve-yayasan',
        saveYayasan: baseUrl + '/api/yayasan/save-yayasan',
        deleteYayasan: baseUrl + '/api/yayasan/delete-yayasan',
        exportExcelYayasan: baseUrl + '/api/yayasan/export-excel-yayasan',
        generateYayasan: baseUrl + '/api/yayasan/generate-yayasan',
        uploadSuratRekomendasiYayasan: baseUrl + '/api/yayasan/upload-surat-rekomendasi-mpkw',
        ubahStatusAktifYayasan: baseUrl + '/api/yayasan/ubah-status-aktif-yayasan',
        checkApprovalYayasan: baseUrl + '/api/yayasan/check-approval-yayasan',
        getUserWithoutYayasan: baseUrl + '/api/yayasan/get-user-without-yayasan',
    },
    wilayah: {
        getProvinsi: baseUrl + '/api/wilayah/get-provinsi',
        getKabupatenKotaByProvinsiKode: baseUrl + '/api/wilayah/get-kabupaten-kota-by-provinsi-kode',
        getKecamatanByKabupatenKotaKode: baseUrl + '/api/wilayah/get-kecamatan-by-kabupaten-kota-kode',
        getKelurahanByKecamatanKode: baseUrl + '/api/wilayah/get-kelurahan-by-kecamatan-kode',
        getKabupatenKotaByListProvinsiKode: baseUrl + '/api/wilayah/get-kabupaten-kota-by-list-provinsi-kode',
        getKecamatanByListKabupatenKotaKode: baseUrl + '/api/wilayah/get-kecamatan-by-list-kabupaten-kota-kode',
        getKelurahanByListKecamatanKode: baseUrl + '/api/wilayah/get-kelurahan-by-list-kecamatan-kode',
    },
    sekolah: {
        getSekolahDropdown: baseUrl + '/api/sekolah/get-sekolah-dropdown',
        getSekolahPaginate: baseUrl + '/api/sekolah/get-sekolah-paginate',
        getSekolahById: baseUrl + '/api/sekolah/get-sekolah-by-id',
        getProvinsi: baseUrl + '/api/sekolah/get-provinsi',
        getKabupatenKotaByListProvinsiKode: baseUrl + '/api/sekolah/get-kabupaten-kota-by-list-provinsi-kode',
        getKabupatenKotaByProvinsiKode: baseUrl + '/api/sekolah/get-kabupaten-kota-by-provinsi-kode',
        getKecamatanByKabupatenKotaKode: baseUrl + '/api/sekolah/get-kecamatan-by-kabupaten-kota-kode',
        getKelurahanByKecamatanKode: baseUrl + '/api/sekolah/get-kelurahan-by-kecamatan-kode',
        getStatusKepemilikan: baseUrl + '/api/sekolah/get-status-kepemilikan',
        getGolonganIuran: baseUrl + '/api/sekolah/get-golongan-iuran',
        getYayasanDropdown: baseUrl + '/api/sekolah/get-yayasan-dropdown',
        getAkreditasiDropdown: baseUrl + '/api/sekolah/get-akreditasi-dropdown',
        getMpkmpkwDropdown: baseUrl + '/api/sekolah/get-mpkmpkw-dropdown',
        getGradeDropdown: baseUrl + '/api/sekolah/get-grade-dropdown',
        getGTKBySekolahId: baseUrl + '/api/sekolah/get-gtk-by-sekolahId-paginate',
        saveSekolah: baseUrl + '/api/sekolah/save-sekolah',
        deleteSekolah: baseUrl + '/api/sekolah/delete-sekolah',
        exportExcelSekolah: baseUrl + '/api/sekolah/export-excel-sekolah',
        ubahStatusAktifSekolah: baseUrl + '/api/sekolah/ubah-status-aktif-sekolah',
    },
    mpkmpkw: {
        getMpkMpkwPaginate: baseUrl + '/api/mpk-mpkw/get-mpk-mpkw-paginate',
        getSekolahByMpkMpkwIdPaginate: baseUrl + '/api/mpk-mpkw/get-sekolah-by-mpk-mpkwId-paginate',
        getMpkMpkwById: baseUrl + '/api/mpk-mpkw/get-mpk-mpkw-by-id',
        getAllMpkMpkw: baseUrl + '/api/mpk-mpkw/get-all-mpk-mpkw',
        saveMpkMpkw: baseUrl + '/api/mpk-mpkw/save-mpk-mpkw',
        deleteMpkMpkw: baseUrl + '/api/mpk-mpkw/delete-mpk-mpkw',
        exportExcelMpkMpkw: baseUrl + '/api/mpk-mpkw/export-excel-mpk-mpkw',
    },
    pengurus: {
        getPengurusDropdown: baseUrl + '/api/pengurus/get-pengurus-dropdown',
        getAllMPKMPKW: baseUrl + '/api/pengurus/get-all-mpk-mpkw',
        getListAktifStrukturOrganisasi: baseUrl + '/api/pengurus/get-list-aktif-struktur-organisasi',
        getListAktifKomisi: baseUrl + '/api/pengurus/get-list-aktif-komisi',
        getListAktifTaskForce: baseUrl + '/api/pengurus/get-list-aktif-task-force',
        getListAktifProgramKerja: baseUrl + '/api/pengurus/get-list-aktif-program-kerja',
        getAllTipeKepegawaian: baseUrl + '/api/pengurus/get-all-tipe-kepegawaian',
        getAllStatusPerkawinan: baseUrl + '/api/pengurus/get-all-status-perkawinan',

        getPengurusPaginate: baseUrl + '/api/pengurus/get-pengurus-paginate',
        getPengurusById: baseUrl + '/api/pengurus/get-pengurus-by-id',
        getProvinsi: baseUrl + '/api/pengurus/get-provinsi',
        getKabupatenKotaByProvinsiKode: baseUrl + '/api/pengurus/get-kabupaten-kota-by-provinsi-kode',
        getKecamatanByKabupatenKotaKode: baseUrl + '/api/pengurus/get-kecamatan-by-kabupaten-kota-kode',
        getKelurahanByKecamatanKode: baseUrl + '/api/pengurus/get-kelurahan-by-kecamatan-kode',

        getKabupatenKotaByListProvinsiKode: baseUrl + '/api/pengurus/get-kabupaten-kota-by-list-provinsi-kode',
        getKecamatanByListKabupatenKotaKode: baseUrl + '/api/pengurus/get-kecamatan-by-list-kabupaten-kota-kode',
        getKelurahanByListKecamatanKode: baseUrl + '/api/pengurus/get-kelurahan-by-list-kecamatan-kode',
        validasiNIK: baseUrl + '/api/pengurus/validasi-nik',

        savePengurus: baseUrl + '/api/pengurus/save-pengurus',
        deletePengurus: baseUrl + '/api/pengurus/delete-pengurus',
        deleteProgramKerjaPengurus: baseUrl + '/api/pengurus/delete-program-kerja-pengurus-mpkw',
        exportExcelPengurus: baseUrl + '/api/pengurus/export-excel-pengurus',
    },
    strukturOrganisasi: {
        getStrukturOrganisasiPaginate: baseUrl + '/api/struktur-organisasi/get-struktur-organisasi-paginate',
        getStrukturOrganisasiById: baseUrl + '/api/struktur-organisasi/get-struktur-organisasi-by-id',
        getPengurusByStrukturOrganisasiId: baseUrl + '/api/struktur-organisasi/get-pengurus-by-struktur-organisasi-id',
        getAllStrukturOrganisasi: baseUrl + '/api/struktur-organisasi/get-all-struktur-organisasi',
        getStatusAktif: baseUrl + '/api/struktur-organisasi/get-status-aktif',
        getAnggota: baseUrl + '/api/struktur-organisasi/get-anggota',
        saveStrukturOrganisasi: baseUrl + '/api/struktur-organisasi/save-struktur-organisasi',
        deleteStrukturOrganisasi: baseUrl + '/api/struktur-organisasi/delete-struktur-organisasi',
        exportExcelStrukturOrganisasi: baseUrl + '/api/struktur-organisasi/export-excel-struktur-organisasi',
    },
    komisi: {
        getKomisiPaginate: baseUrl + '/api/komisi/get-komisi-paginate',
        getKomisiById: baseUrl + '/api/komisi/get-komisi-by-id',
        getPengurusByKomisiId: baseUrl + '/api/komisi/get-pengurus-by-komisi-id',
        getStrukturOrganisasiBidang: baseUrl + '/api/komisi/get-struktur-organisasi-bidang',
        getAllKomisi: baseUrl + '/api/komisi/get-all-komisi',
        getStatusAktif: baseUrl + '/api/komisi/get-status-aktif',
        getAnggota: baseUrl + '/api/komisi/get-anggota',
        saveKomisi: baseUrl + '/api/komisi/save-komisi',
        deleteKomisi: baseUrl + '/api/komisi/delete-komisi',
        exportExcelKomisi: baseUrl + '/api/komisi/export-excel-komisi',
    },
    taskForce: {
        getTaskForcePaginate: baseUrl + '/api/task-force/get-task-force-paginate',
        getTaskForceById: baseUrl + '/api/task-force/get-task-force-by-id',
        getPengurusByTaskForceId: baseUrl + '/api/task-force/get-pengurus-by-task-force-id',
        getAllTaskForce: baseUrl + '/api/task-force/get-all-task-force',
        getStatusAktif: baseUrl + '/api/task-force/get-status-aktif',
        getAnggota: baseUrl + '/api/task-force/get-anggota',
        saveTaskForce: baseUrl + '/api/task-force/save-task-force',
        deleteTaskForce: baseUrl + '/api/task-force/delete-task-force',
        exportExcelTaskForce: baseUrl + '/api/task-force/export-excel-task-force',
    },
    programKerja: {
        getProgramKerjaPaginate: baseUrl + '/api/programkerja/get-program-kerja-paginate',
        getProgramKerjaById: baseUrl + '/api/programkerja/get-program-kerja-by-id',
        getListStrukturOrganisasi: baseUrl + '/api/programkerja/get-list-struktur-organisasi',
        // getListKomisi: baseUrl + '/api/programkerja/get-list-komisi',
        getKomisiByListStrukturOrganisasi: baseUrl + '/api/programkerja/get-komisi-by-list-struktur-organisasi-id',
        getKomisiByStrukturOrganisasiId: baseUrl + '/api/programkerja/get-komisi-by-struktur-organisasi-id',
        getListKomite: baseUrl + '/api/programkerja/get-list-komite',
        getListMisiProgramKerja: baseUrl + '/api/programkerja/get-list-misi-program-kerja',
        getListKategoriProgramKerja: baseUrl + '/api/programkerja/get-list-kategori-program-kerja',
        saveProgramKerja: baseUrl + '/api/programkerja/save-program-kerja',
        deleteProgramKerja: baseUrl + '/api/programkerja/delete-program-kerja',
        exportExcelProgramKerja: baseUrl + '/api/programkerja/export-excel-program-kerja',
    },
    manajemenAnggota: {
        yayasan: {
            getYayasanById: baseUrl + '/api/manajemen-anggota/yayasan/get-yayasan-by-id',
            getYayasanByNPYP: baseUrl + '/api/manajemen-anggota/yayasan/get-yayasan-by-npyp',
            getMemberYayasanPaginate: baseUrl + '/api/manajemen-anggota/yayasan/get-member-yayasan-paginate',
            getProvinsi: baseUrl + '/api/manajemen-anggota/yayasan/get-provinsi',
            getAllKabupatenKota: baseUrl + '/api/manajemen-anggota/yayasan/get-all-kabupaten-kota',
            getAllKecamatan: baseUrl + '/api/manajemen-anggota/yayasan/get-all-kecamatan',
            getAllKelurahan: baseUrl + '/api/manajemen-anggota/yayasan/get-all-kelurahan',
            getKabupatenKotaByProvinsiKode: baseUrl + '/api/manajemen-anggota/yayasan/get-kabupaten-kota-by-provinsi-kode',
            getKabupatenKotaByListProvinsiKode: baseUrl + '/api/manajemen-anggota/yayasan/get-kabupaten-kota-by-list-provinsi-kode',
            getKecamatanByKabupatenKotaKode: baseUrl + '/api/manajemen-anggota/yayasan/get-kecamatan-by-kabupaten-kota-kode',
            getKelurahanByKecamatanKode: baseUrl + '/api/manajemen-anggota/yayasan/get-kelurahan-by-kecamatan-kode',
            getStatusKepemilikan: baseUrl + '/api/manajemen-anggota/yayasan/get-status-kepemilikan',
            getAllMPKMPKW: baseUrl + '/api/manajemen-anggota/yayasan/get-all-mpk-mpkw',
            getAllStatusApprovalKeanggotaanYayasan: baseUrl + '/api/manajemen-anggota/yayasan/get-all-status-approval-keanggotaan-yayasan',
            saveYayasan: baseUrl + '/api/manajemen-anggota/yayasan/save-yayasan'
        },
        sekolah: {
            getSekolahPaginate: baseUrl + '/api/manajemen-anggota/sekolah/get-sekolah-paginate',
            getSekolahById: baseUrl + '/api/manajemen-anggota/sekolah/get-sekolah-by-id',
            getProvinsi: baseUrl + '/api/manajemen-anggota/sekolah/get-provinsi',
            getKabupatenKotaByListProvinsiKode: baseUrl + '/api/manajemen-anggota/sekolah/get-kabupaten-kota-by-list-provinsi-kode',
            getKabupatenKotaByProvinsiKode: baseUrl + '/api/manajemen-anggota/sekolah/get-kabupaten-kota-by-provinsi-kode',
            getKecamatanByKabupatenKotaKode: baseUrl + '/api/manajemen-anggota/sekolah/get-kecamatan-by-kabupaten-kota-kode',
            getKelurahanByKecamatanKode: baseUrl + '/api/manajemen-anggota/sekolah/get-kelurahan-by-kecamatan-kode',
            getStatusKepemilikan: baseUrl + '/api/manajemen-anggota/sekolah/get-status-kepemilikan',
            getGolonganIuran: baseUrl + '/api/manajemen-anggota/sekolah/get-golongan-iuran',
            getYayasanDropdown: baseUrl + '/api/manajemen-anggota/sekolah/get-yayasan-dropdown',
            getAkreditasiDropdown: baseUrl + '/api/manajemen-anggota/sekolah/get-akreditasi-dropdown',
            getMpkmpkwDropdown: baseUrl + '/api/manajemen-anggota/sekolah/get-mpkmpkw-dropdown',
            getGradeDropdown: baseUrl + '/api/manajemen-anggota/sekolah/get-grade-dropdown',
            getGTKBySekolahId: baseUrl + '/api/manajemen-anggota/sekolah/get-gtk-by-sekolahId-paginate',
            saveSekolah: baseUrl + '/api/manajemen-anggota/sekolah/save-sekolah',
            deleteSekolah: baseUrl + '/api/manajemen-anggota/sekolah/delete-sekolah',
            exportExcelSekolah: baseUrl + '/api/manajemen-anggota/sekolah/export-excel-sekolah',
        },
        validasiPembayaranIuran: {
            getAllYayasanOptions: baseUrl + '/api/validasi-pembayaran-iuran/get-all-yayasan-options',
            getPembayaranPaginate: baseUrl + '/api/validasi-pembayaran-iuran/get-pembayaran-iuran-paginate',
            getPembayaranById: baseUrl + '/api/validasi-pembayaran-iuran/get-pembayaran-iuran-by-id',
            updatePembayaran: baseUrl + '/api/validasi-pembayaran-iuran/update-pembayaran-iuran',
        },
    },
    trainer: {
        getTrainerPaginate: baseUrl + '/api/trainer/get-trainer-paginate',
        getTrainerById: baseUrl + '/api/trainer/get-trainer-by-id',
        getProvinsi: baseUrl + '/api/trainer/get-provinsi',
        getKabupatenKotaByProvinsiKode: baseUrl + '/api/trainer/get-kabupaten-kota-by-provinsi-kode',
        getKabupatenKotaByListProvinsiKode: baseUrl + '/api/trainer/get-kabupaten-kota-by-list-provinsi-kode',
        getKecamatanByKabupatenKotaKode: baseUrl + '/api/trainer/get-kecamatan-by-kabupaten-kota-kode',
        getKelurahanByKecamatanKode: baseUrl + '/api/trainer/get-kelurahan-by-kecamatan-kode',
        getStatusTraining: baseUrl + '/api/trainer/get-status-training',
        getSekolah: baseUrl + '/api/trainer/get-sekolah-dropdown',
        saveTrainer: baseUrl + '/api/trainer/save-trainer',
        deleteTrainer: baseUrl + '/api/trainer/delete-trainer',
        exportExcelTrainer: baseUrl + '/api/trainer/export-excel-trainer',
    },
    pengaturan: {
        getDataPerHalaman: baseUrl + '/api/Pengaturan/get-data-per-halaman-table',
        saveDataPerHalaman: baseUrl + '/api/Pengaturan/save-data-per-halaman-table',
        saveUploadLogo: baseUrl + '/api/Pengaturan/upload-logo',
    },
    mitra: {
        getMitraPaginate: baseUrl + '/api/mitra/get-mitra-paginate',
        getMitraById: baseUrl + '/api/mitra/get-mitra-by-id',
        saveMitra: baseUrl + '/api/mitra/save-mitra',
        deleteMitra: baseUrl + '/api/mitra/delete-mitra',
        exportExcelMitra: baseUrl + '/api/mitra/export-excel-mitra',
        saveMitraDebug: baseUrl + '/api/mitra/save-mitra-debug',
        getAktifMitraDropdown: baseUrl + '/api/mitra/get-aktif-mitra-dropdown'
    },
    tipeRelasiMitra: {
        getAll: baseUrl + '/api/tipe-relasi-mitra/get-all',
    },
    gtk: {
        getGTKPaginate: baseUrl + "/api/gtk/get-gtk-paginate",
        getGTKById: baseUrl + "/api/gtk/get-gtk-by-id",
        getSekolah: baseUrl + "/api/gtk/get-sekolah",
        getSekolahByMPKMPKW: baseUrl + "/api/gtk/get-sekolah-by-mpkw",
        getKategoriGTK: baseUrl + "/api/gtk/get-kategori-gtk",
        getMPKMPKW: baseUrl + "/api/gtk/get-mpk-mpkw",
        getStatusPerkawinan: baseUrl + "/api/gtk/get-status-perkawinan",
        getTipeKepegawaianGTK: baseUrl + "/api/gtk/get-tipe-kepegawaian-gtk",
        getRentangGajiGTK: baseUrl + "/api/gtk/get-rentang-gaji-gtk",
        getJenjangPendidikan: baseUrl + "/api/gtk/get-jenjang-pendidikan",
        getMataPelajaran: baseUrl + "/api/gtk/get-mata-pelajaran",
        getJurusan: baseUrl + "/api/gtk/get-jurusan",
        getProvinsi: baseUrl + "/api/gtk/get-provinsi",
        getKabupatenKotaByProvinsiKode:
            baseUrl + "/api/gtk/get-kabupaten-kota-by-provinsi-kode",
        getKabupatenKotaByListProvinsiKode:
            baseUrl + "/api/gtk/get-kabupaten-kota-by-list-provinsi-kode",
        getKecamatanByKabupatenKotaKode:
            baseUrl + "/api/gtk/get-kecamatan-by-kabupaten-kota-kode",
        getKelurahanByKecamatanKode:
            baseUrl + "/api/gtk/get-kelurahan-by-kecamatan-kode",
        saveGTK: baseUrl + "/api/gtk/save-gtk",
        deleteGTK: baseUrl + "/api/gtk/delete-gtk",
        exportExcelGTK: baseUrl + "/api/gtk/export-excel-gtk",
        saveCalonGuru: baseUrl + "/api/gtk/save-calon-guru",
        getAgama: baseUrl + "/api/gtk/get-agama",
        getKeahlianLaboratorium: baseUrl + "/api/gtk/get-keahlian-laboratorium",
        getAllStatusApprovalKeanggotaanGUKI: baseUrl + '/api/gtk/get-all-status-approval-keanggotaan-guki',
        getAllStatusKeanggotaanGUKI: baseUrl + '/api/gtk/get-all-status-keanggotaan-guki',
        approveKeanggotaanGUKI: baseUrl + '/api/gtk/approve-keanggotaan-guki',
        rejectKeanggotaanGUKI: baseUrl + '/api/gtk/reject-keanggotaan-guki',
        deleteMataPelajaran: baseUrl + "/api/gtk/delete-mata-pelajaran",
        deleteJurusan: baseUrl + "/api/gtk/delete-jurusan",
    },
    manajemenRole: {
        getManajemenRolePaginate: baseUrl + '/api/manajemenrole/get-manajemen-role-paginate',
        getUserById: baseUrl + '/api/manajemenrole/get-user-by-id',
        updateUserRole: baseUrl + '/api/manajemenrole/update-user-roles',
        getListRole: baseUrl + '/api/manajemenrole/get-role',
        saveRole: baseUrl + '/api/manajemenrole/save-role',
        deleteRole: baseUrl + '/api/manajemenrole/delete-role',
        getRolePermissionPaginate: baseUrl + '/api/manajemenrole/get-role-permission-paginate',
        saveRolePermission: baseUrl + '/api/manajemenrole/save-role-permission',
    },
    metabaseReports: {
        getMetabaseReports: baseUrl + '/api/metabase-reports/get-metabase-reports',
        getMetabaseReportById: baseUrl + '/api/metabase-reports/get-metabase-report-by-id',
        validateMetabaseReport: baseUrl + '/api/metabase-reports/validate-metabase-report',
        createMetabaseReport: baseUrl + '/api/metabase-reports/create-metabase-report',
        updateMetabaseReport: baseUrl + '/api/metabase-reports/update-metabase-report',
        deleteMetabaseReport: baseUrl + '/api/metabase-reports/delete-metabase-report',
    },
    reporting: {
        getReportEmbedUrl: baseUrl + '/api/reporting/get-report-embed-url',
        getReportMenuItem: baseUrl + '/api/reporting/get-report-menu-item',
    },
    roles: {
        getRoles: baseUrl + '/api/roles',
    },
    payment: {
        getPaymentData: baseUrl + '/api/payment',
        getHistoryList: baseUrl + '/api/payment/history',
        getSubPaymentData: baseUrl + '/api/payment/sub-payment',
        updatePaymentData: baseUrl + '/api/payment/update-iuran',
        getTagihanData: baseUrl + '/api/payment/tagihan',
        createManualPayment: baseUrl + '/api/payment/manual-payment',
        getStatusPembayaran: baseUrl + '/api/payment/check-status',
        exportHistoryExcel: baseUrl + '/api/payment/export-excel-history',
        getPdfFaktur: baseUrl + '/api/Payment/pdf-paid-faktur',
        triggerIuranTagihan: baseUrl + '/api/payment/trigger-iuran-tagihan',
    },
    permission: {
        get: baseUrl + '/api/permission/get'
    },
    manajemenAlumniFkip: {
        getManajemenFkipFilterOptions: baseUrl + '/api/manajemen-alumni-fkip/get-alumni-fkip-filter-options',
        getManajemenAlumniFkipList: baseUrl + '/api/manajemen-alumni-fkip/get-alumni-fkip-list',
        getAlumniFkipDataByid: baseUrl + '/api/manajemen-alumni-fkip/get-alumni-fkip-by-id',
        saveManajemenFkip: baseUrl + '/api/manajemen-alumni-fkip/save-alumni-fkip',
        deleteAlumniFkipId: baseUrl + '/api/manajemen-alumni-fkip/delete-alumni-fkip',
        getAlumniFkipExcelData: baseUrl + '/api/manajemen-alumni-fkip/export-excel-alumni-fkip',
        uploadExcelAlumniFkipData: baseUrl + '/api/manajemen-alumni-fkip/upload-alumni-fkip-bulk',
        getAlumniFkipTemplate: baseUrl + '/api/manajemen-alumni-fkip/export-excel-alumni-fkip-template',
        publicSubmit: baseUrl + '/api/alumni-fkip-public/save'
    },
    manajemenCalonGuru: {
        getManajemenCalonGuruFilterOptions: baseUrl + '/api/manajemen-calon-guru/get-calon-guru-filter-options',
        getManajemenCalonGuruList: baseUrl + '/api/manajemen-calon-guru/get-calon-guru-list',
        saveManajemenCalonGuruData: baseUrl + '/api/manajemen-calon-guru/save-calon-guru-data',
        getManajemenCalonGuruById: baseUrl + '/api/manajemen-calon-guru/get-calon-guru-by-id',
        deleteManajemenCalonGuru: baseUrl + '/api/manajemen-calon-guru/delete-calon-guru',
        getManajemenCalonGuruExcelData: baseUrl + '/api/manajemen-calon-guru/export-excel-calon-guru',
        uploadExcelCalonGuruData: baseUrl + '/api/manajemen-calon-guru/upload-calon-guru-bulk',
        getCalonGuruTemplate: baseUrl + '/api/manajemen-calon-guru/export-excel-calon-guru-template'
    },
};

export function GetMemberYayasanList(
    filterYayasan: FilterYayasan
) {
    const param = new URLSearchParams();

    if (filterYayasan.sortField !== undefined) {
        param.append("sortField", filterYayasan.sortField.toString());
    }
    if (filterYayasan.sortOrder !== undefined) {
        param.append("sortOrder", filterYayasan.sortOrder.toString());
    }
    if (filterYayasan.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterYayasan.itemsPerPage.toString());
    }
    if (filterYayasan.page !== undefined) {
        param.append("page", filterYayasan.page.toString());
    }

    return BackendApiUrl.yayasan.getMemberYayasanPaginate + "?" + param.toString();
}

export function GetAnggotaSekolahList(filterSekolah: FilterSekolahPage, yayasanId: string | undefined) {
    const param = new URLSearchParams();

    if (yayasanId !== undefined) {
        param.append("yayasanId", yayasanId.toString());
    }

    if (filterSekolah.namaSekolah !== undefined) {
        param.append("nama", filterSekolah.namaSekolah.toString());
    }
    if (filterSekolah.npsn !== undefined) {
        param.append("npsn", filterSekolah.npsn.toString());
    }

    if (filterSekolah.listJenisSekolah != undefined && filterSekolah.listJenisSekolah?.length > 0) {
        filterSekolah.listJenisSekolah.forEach(id => {
            param.append('listJenisSekolah', id);
        });
    }

    if (filterSekolah.listAkreditasi != undefined && filterSekolah.listAkreditasi?.length > 0) {
        filterSekolah.listAkreditasi.forEach(id => {
            param.append('listAkreditasi', id);
        });
    }

    if (filterSekolah.listProvinsiKode != undefined && filterSekolah.listProvinsiKode?.length > 0) {
        filterSekolah.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }

    if (filterSekolah.listKabupatenKotaKode != undefined && filterSekolah.listKabupatenKotaKode?.length > 0) {
        filterSekolah.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }

    if (filterSekolah.listGrade != undefined && filterSekolah.listGrade?.length > 0) {
        filterSekolah.listGrade.forEach(id => {
            param.append('listGrade', id);
        });
    }

    if (filterSekolah.listMPKW != undefined && filterSekolah.listMPKW?.length > 0) {
        filterSekolah.listMPKW.forEach(id => {
            param.append('listMPKW', id);
        });
    }

    if (filterSekolah.nomorAnggotaSekolahMpk !== undefined) {
        param.append("nomorAnggotaSekolahMpk", filterSekolah.nomorAnggotaSekolahMpk.toString());
    }
    if (filterSekolah.sortField !== undefined) {
        param.append("sortField", filterSekolah.sortField.toString());
    }
    if (filterSekolah.sortOrder !== undefined) {
        param.append("sortOrder", filterSekolah.sortOrder.toString());
    }
    if (filterSekolah.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterSekolah.itemsPerPage.toString());
    }
    if (filterSekolah.page !== undefined) {
        param.append("page", filterSekolah.page.toString());
    }

    return BackendApiUrl.manajemenAnggota.sekolah.getSekolahPaginate + "?" + param.toString();
}

export function GetDashboardCounts() {
    return BackendApiUrl.dashboard.getDashboardCounts;
}

export function GetValidasiPembayaranIuranList(
    filterValidasiPembayaranIuran: FilterValidasiPembayaranIuran
) {
    const param = new URLSearchParams();


    if (filterValidasiPembayaranIuran.tanggalDari !== undefined && filterValidasiPembayaranIuran.tanggalDari !== null) {
        const tanggalDari = dayjs(filterValidasiPembayaranIuran.tanggalDari).format("YYYY-MM-DD");
        param.append("tanggalDari", tanggalDari);
    }
    if (filterValidasiPembayaranIuran.tanggalKe !== undefined && filterValidasiPembayaranIuran.tanggalKe !== null) {
        const tanggalKe = dayjs(filterValidasiPembayaranIuran.tanggalKe).format("YYYY-MM-DD");
        param.append("tanggalKe", tanggalKe);
    }

    if (filterValidasiPembayaranIuran.yayasanId !== undefined && filterValidasiPembayaranIuran.yayasanId !== null) {
        param.append("yayasanId", filterValidasiPembayaranIuran.yayasanId);
    }

    if (filterValidasiPembayaranIuran.listStatusPembayaran != undefined && filterValidasiPembayaranIuran.listStatusPembayaran?.length > 0) {
        filterValidasiPembayaranIuran.listStatusPembayaran.forEach(id => {
            param.append('listStatusPembayaran', id);
        });
    }

    if (filterValidasiPembayaranIuran.sortField !== undefined) {
        param.append("sortField", filterValidasiPembayaranIuran.sortField.toString());
    }
    if (filterValidasiPembayaranIuran.sortOrder !== undefined) {
        param.append("sortOrder", filterValidasiPembayaranIuran.sortOrder.toString());
    }
    if (filterValidasiPembayaranIuran.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterValidasiPembayaranIuran.itemsPerPage.toString());
    }
    if (filterValidasiPembayaranIuran.page !== undefined) {
        param.append("page", filterValidasiPembayaranIuran.page.toString());
    }

    return BackendApiUrl.manajemenAnggota.validasiPembayaranIuran.getPembayaranPaginate + "?" + param.toString();
}

export function GetYayasanList(
    filterYayasan: FilterYayasan
) {
    const param = new URLSearchParams();
    if (filterYayasan.namaYayasan !== undefined) {
        param.append("namaYayasan", filterYayasan.namaYayasan.toString());
    }
    if (filterYayasan.npyp !== undefined) {
        param.append("NPYP", filterYayasan.npyp.toString());
    }
    if (filterYayasan.mpkw !== undefined) {
        param.append("MPKW", filterYayasan.mpkw.toString());
    }
    if (filterYayasan.nomorAnggotaMPK !== undefined) {
        param.append("nomorAnggotaMPK", filterYayasan.nomorAnggotaMPK.toString());
    }

    if (filterYayasan.listStatusApproval != undefined && filterYayasan.listStatusApproval?.length > 0) {
        filterYayasan.listStatusApproval.forEach(id => {
            param.append('listStatusApproval', id);
        });
    }

    if (filterYayasan.listProvinsiKode != undefined && filterYayasan.listProvinsiKode?.length > 0) {
        filterYayasan.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }

    if (filterYayasan.listKabupatenKotaKode != undefined && filterYayasan.listKabupatenKotaKode?.length > 0) {
        filterYayasan.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }

    if (filterYayasan.sortField !== undefined) {
        param.append("sortField", filterYayasan.sortField.toString());
    }
    if (filterYayasan.sortOrder !== undefined) {
        param.append("sortOrder", filterYayasan.sortOrder.toString());
    }
    if (filterYayasan.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterYayasan.itemsPerPage.toString());
    }
    if (filterYayasan.page !== undefined) {
        param.append("page", filterYayasan.page.toString());
    }

    return BackendApiUrl.yayasan.getYayasanPaginate + "?" + param.toString();
}


export function GetSekolahByYayasanIdList(
    filterSekolah: FilterSekolah
) {
    const param = new URLSearchParams();

    if (filterSekolah.yayasanId !== undefined) {
        param.append("yayasanId", filterSekolah.yayasanId.toString());
    }
    if (filterSekolah.sortField !== undefined) {
        param.append("sortField", filterSekolah.sortField.toString());
    }
    if (filterSekolah.sortOrder !== undefined) {
        param.append("sortOrder", filterSekolah.sortOrder.toString());
    }
    if (filterSekolah.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterSekolah.itemsPerPage.toString());
    }
    if (filterSekolah.page !== undefined) {
        param.append("page", filterSekolah.page.toString());
    }

    return BackendApiUrl.yayasan.getSekolahByYayasanIdPaginate + "?" + param.toString();
}

export function GetGTKList(
    filterGTK: FilterGTK
) {
    const param = new URLSearchParams();
    if (filterGTK.namaDepan !== undefined) {
        param.append("namaDepan", filterGTK.namaDepan.toString());
    }
    if (filterGTK.namaTengah !== undefined) {
        param.append("namaTengah", filterGTK.namaTengah.toString());
    }
    if (filterGTK.namaBelakang !== undefined) {
        param.append("namaBelakang", filterGTK.namaBelakang.toString());
    }
    if (filterGTK.sekolah !== undefined) {
        param.append("sekolahId", filterGTK.sekolah.toString());
    }
    if (filterGTK.mpkw !== undefined) {
        param.append("mpkMpkwId", filterGTK.mpkw.toString());
    }
    if (filterGTK.listKategoriGTK !== undefined && filterGTK.listKategoriGTK?.length > 0) {
        filterGTK.listKategoriGTK.forEach(id => {
            param.append("listKategoriGTKId", id);
        })
    }
    if (filterGTK.listProvinsiKode != undefined && filterGTK.listProvinsiKode?.length > 0) {
        filterGTK.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }
    if (filterGTK.listKabupatenKotaKode != undefined && filterGTK.listKabupatenKotaKode?.length > 0) {
        filterGTK.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }
    if (filterGTK.nomorAnggotaGUKI !== undefined) {
        param.append("nomorAnggotaGUKI", filterGTK.nomorAnggotaGUKI.toString());
    }
     if (filterGTK.listStatusApprovalKeanggotaanGUKI !== undefined && filterGTK.listStatusApprovalKeanggotaanGUKI?.length > 0) {
        filterGTK.listStatusApprovalKeanggotaanGUKI.forEach(id => {
            param.append("listStatusApprovalKeanggotaanGUKI", id);
        })
    }
    if (filterGTK.sortField !== undefined) {
        param.append("sortField", filterGTK.sortField.toString());
    }
    if (filterGTK.sortOrder !== undefined) {
        param.append("sortOrder", filterGTK.sortOrder.toString());
    }
    if (filterGTK.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterGTK.itemsPerPage.toString());
    }
    if (filterGTK.page !== undefined) {
        param.append("page", filterGTK.page.toString());
    }

    return BackendApiUrl.gtk.getGTKPaginate + "?" + param.toString();
}

export function ExportExcelYayasan(
    filterYayasan: FilterYayasan
) {
    const param = new URLSearchParams();
    if (filterYayasan.namaYayasan !== undefined) {
        param.append("namaYayasan", filterYayasan.namaYayasan.toString());
    }
    if (filterYayasan.npyp !== undefined) {
        param.append("NPYP", filterYayasan.npyp.toString());
    }
    if (filterYayasan.mpkw !== undefined) {
        param.append("MPKW", filterYayasan.mpkw.toString());
    }
    if (filterYayasan.nomorAnggotaMPK !== undefined) {
        param.append("nomorAnggotaMPK", filterYayasan.nomorAnggotaMPK.toString());
    }

    if (filterYayasan.listStatusApproval != undefined && filterYayasan.listStatusApproval?.length > 0) {
        filterYayasan.listStatusApproval.forEach(id => {
            param.append('listStatusApproval', id);
        });
    }

    if (filterYayasan.listProvinsiKode != undefined && filterYayasan.listProvinsiKode?.length > 0) {
        filterYayasan.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }

    if (filterYayasan.listKabupatenKotaKode != undefined && filterYayasan.listKabupatenKotaKode?.length > 0) {
        filterYayasan.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }

    if (filterYayasan.sortField !== undefined) {
        param.append("sortField", filterYayasan.sortField.toString());
    }
    if (filterYayasan.sortOrder !== undefined) {
        param.append("sortOrder", filterYayasan.sortOrder.toString());
    }

    return BackendApiUrl.yayasan.exportExcelYayasan + "?" + param.toString();
}

export function ExportExcelGTK(
    filterGTK: FilterGTK
) {
    const param = new URLSearchParams();
    if (filterGTK.namaDepan !== undefined) {
        param.append("namaDepan", filterGTK.namaDepan.toString());
    }
    if (filterGTK.namaTengah !== undefined) {
        param.append("namaTengah", filterGTK.namaTengah.toString());
    }
    if (filterGTK.namaBelakang !== undefined) {
        param.append("namaBelakang", filterGTK.namaBelakang.toString());
    }
    if (filterGTK.sekolah !== undefined) {
        param.append("sekolahId", filterGTK.sekolah.toString());
    }
    if (filterGTK.mpkw !== undefined) {
        param.append("mpkMpkwId", filterGTK.mpkw.toString());
    }
    if (filterGTK.listKategoriGTK !== undefined && filterGTK.listKategoriGTK?.length > 0) {
        filterGTK.listKategoriGTK.forEach(id => {
            param.append("listKategoriGTKId", id);
        })
    }
    if (filterGTK.listProvinsiKode != undefined && filterGTK.listProvinsiKode?.length > 0) {
        filterGTK.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }
    if (filterGTK.listKabupatenKotaKode != undefined && filterGTK.listKabupatenKotaKode?.length > 0) {
        filterGTK.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }
    if (filterGTK.nomorAnggotaGUKI !== undefined) {
        param.append("nomorAnggotaGUKI", filterGTK.nomorAnggotaGUKI.toString());
    }
    if (filterGTK.listStatusApprovalKeanggotaanGUKI !== undefined && filterGTK.listStatusApprovalKeanggotaanGUKI?.length > 0) {
        filterGTK.listStatusApprovalKeanggotaanGUKI.forEach(id => {
            param.append("listStatusApprovalKeanggotaanGUKI", id);
        })
    }
    if (filterGTK.sortField !== undefined) {
        param.append("sortField", filterGTK.sortField.toString());
    }
    if (filterGTK.sortOrder !== undefined) {
        param.append("sortOrder", filterGTK.sortOrder.toString());
    }

    return BackendApiUrl.gtk.exportExcelGTK + "?" + param.toString();
}

export function GetSekolahList(filterSekolah: FilterSekolahPage) {
    const param = new URLSearchParams();

    if (filterSekolah.namaSekolah !== undefined) {
        param.append("nama", filterSekolah.namaSekolah.toString());
    }
    if (filterSekolah.npsn !== undefined) {
        param.append("npsn", filterSekolah.npsn.toString());
    }

    if (filterSekolah.listJenisSekolah != undefined && filterSekolah.listJenisSekolah?.length > 0) {
        filterSekolah.listJenisSekolah.forEach(id => {
            param.append('listJenisSekolah', id);
        });
    }

    if (filterSekolah.listAkreditasi != undefined && filterSekolah.listAkreditasi?.length > 0) {
        filterSekolah.listAkreditasi.forEach(id => {
            param.append('listAkreditasi', id);
        });
    }

    if (filterSekolah.listProvinsiKode != undefined && filterSekolah.listProvinsiKode?.length > 0) {
        filterSekolah.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }

    if (filterSekolah.listKabupatenKotaKode != undefined && filterSekolah.listKabupatenKotaKode?.length > 0) {
        filterSekolah.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }

    if (filterSekolah.listGrade != undefined && filterSekolah.listGrade?.length > 0) {
        filterSekolah.listGrade.forEach(id => {
            param.append('listGrade', id);
        });
    }

    if (filterSekolah.listMPKW != undefined && filterSekolah.listMPKW?.length > 0) {
        filterSekolah.listMPKW.forEach(id => {
            param.append('listMPKW', id);
        });
    }

    if (filterSekolah.jenisSekolah !== undefined) {
        const jenisValue = filterSekolah.jenisSekolah === "0" ? "negeri" : "swasta";
        param.append("jenisSekolah", jenisValue);
    }
    if (filterSekolah.akreditasi !== undefined) {
        param.append("akreditasi", filterSekolah.akreditasi.toString());
    }
    if (filterSekolah.provinsiKode !== undefined) {
        param.append("provinsiKode", filterSekolah.provinsiKode.toString());
    }
    if (filterSekolah.kabupatenKotaKode !== undefined) {
        param.append("kabupatenKotaKode", filterSekolah.kabupatenKotaKode.toString());
    }
    if (filterSekolah.grade !== undefined) {
        param.append("grade", filterSekolah.grade.toString());
    }
    if (filterSekolah.mpkmpkw !== undefined) {
        param.append("mpkmpkw", filterSekolah.mpkmpkw.toString());
    }
    if (filterSekolah.nomorAnggotaSekolahMpk !== undefined) {
        param.append("nomorAnggotaSekolahMpk", filterSekolah.nomorAnggotaSekolahMpk.toString());
    }
    if (filterSekolah.sortField !== undefined) {
        param.append("sortField", filterSekolah.sortField.toString());
    }
    if (filterSekolah.sortOrder !== undefined) {
        param.append("sortOrder", filterSekolah.sortOrder.toString());
    }
    if (filterSekolah.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterSekolah.itemsPerPage.toString());
    }
    if (filterSekolah.page !== undefined) {
        param.append("page", filterSekolah.page.toString());
    }

    return BackendApiUrl.sekolah.getSekolahPaginate + "?" + param.toString();

}

export function ExportExcelPelamarBeasiswa(filter: FilterPelamarBeasiswa) {
    const param = new URLSearchParams();
    if (filter.nama) param.append("nama", filter.nama);
    if (filter.tanggalPendaftaranDari) param.append("tanggalPendaftaranDari", filter.tanggalPendaftaranDari.format("YYYY-MM-DD"));
    if (filter.tanggalPendaftaranKe) param.append("tanggalPendaftaranKe", filter.tanggalPendaftaranKe.format("YYYY-MM-DD"));
    if (filter.statusPendaftarBeasiswaId) param.append("statusPendaftarBeasiswaId", filter.statusPendaftarBeasiswaId);

    if (filter.sortField) param.append("sortField", filter.sortField);
    if (filter.sortOrder) param.append("sortOrder", filter.sortOrder);

    return BackendApiUrl.pelamarBeasiswa.exportExcel + "?" + param.toString();
}

export function ExportExcelSekolah(filterSekolah: FilterSekolahPage) {
    const param = new URLSearchParams();

    if (filterSekolah.namaSekolah !== undefined) {
        param.append("nama", filterSekolah.namaSekolah.toString());
    }
    if (filterSekolah.npsn !== undefined) {
        param.append("npsn", filterSekolah.npsn.toString());
    }

    if (filterSekolah.listJenisSekolah != undefined && filterSekolah.listJenisSekolah?.length > 0) {
        filterSekolah.listJenisSekolah.forEach(id => {
            param.append('listJenisSekolah', id);
        });
    }

    if (filterSekolah.listAkreditasi != undefined && filterSekolah.listAkreditasi?.length > 0) {
        filterSekolah.listAkreditasi.forEach(id => {
            param.append('listAkreditasi', id);
        });
    }

    if (filterSekolah.listProvinsiKode != undefined && filterSekolah.listProvinsiKode?.length > 0) {
        filterSekolah.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }

    if (filterSekolah.listKabupatenKotaKode != undefined && filterSekolah.listKabupatenKotaKode?.length > 0) {
        filterSekolah.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }

    if (filterSekolah.listGrade != undefined && filterSekolah.listGrade?.length > 0) {
        filterSekolah.listGrade.forEach(id => {
            param.append('listGrade', id);
        });
    }

    if (filterSekolah.listMPKW != undefined && filterSekolah.listMPKW?.length > 0) {
        filterSekolah.listMPKW.forEach(id => {
            param.append('listMPKW', id);
        });
    }

    if (filterSekolah.jenisSekolah !== undefined) {
        const jenisValue = filterSekolah.jenisSekolah === "0" ? "negeri" : "swasta";
        param.append("jenisSekolah", jenisValue);
    }
    if (filterSekolah.akreditasi !== undefined) {
        param.append("akreditasi", filterSekolah.akreditasi.toString());
    }
    if (filterSekolah.provinsiKode !== undefined) {
        param.append("provinsiKode", filterSekolah.provinsiKode.toString());
    }
    if (filterSekolah.kabupatenKotaKode !== undefined) {
        param.append("kabupatenKotaKode", filterSekolah.kabupatenKotaKode.toString());
    }
    if (filterSekolah.grade !== undefined) {
        param.append("grade", filterSekolah.grade.toString());
    }
    if (filterSekolah.mpkmpkw !== undefined) {
        param.append("mpkmpkw", filterSekolah.mpkmpkw.toString());
    }
    if (filterSekolah.nomorAnggotaSekolahMpk !== undefined) {
        param.append("nomorAnggotaSekolahMpk", filterSekolah.nomorAnggotaSekolahMpk.toString());
    }
    if (filterSekolah.sortField !== undefined) {
        param.append("sortField", filterSekolah.sortField.toString());
    }
    if (filterSekolah.sortOrder !== undefined) {
        param.append("sortOrder", filterSekolah.sortOrder.toString());
    }

    return BackendApiUrl.sekolah.exportExcelSekolah + "?" + param.toString();
}

export function GetGTKBySekolahIdList(
    gtkSekolah: GTKSekolahFilter
) {
    const param = new URLSearchParams();

    if (gtkSekolah.sekolahId !== undefined) {
        param.append("sekolahId", gtkSekolah.sekolahId.toString());
    }
    if (gtkSekolah.sortField !== undefined) {
        param.append("sortField", gtkSekolah.sortField.toString());
    }
    if (gtkSekolah.sortOrder !== undefined) {
        param.append("sortOrder", gtkSekolah.sortOrder.toString());
    }
    if (gtkSekolah.itemsPerPage !== undefined) {
        param.append("itemsPerPage", gtkSekolah.itemsPerPage.toString());
    }
    if (gtkSekolah.page !== undefined) {
        param.append("page", gtkSekolah.page.toString());
    }

    return BackendApiUrl.sekolah.getGTKBySekolahId + "?" + param.toString();
}

export function GetMpkMpkwList(
    filterMpkMpkw: FilterMpkMpkw
) {
    const param = new URLSearchParams();
    if (filterMpkMpkw.listMPKMPKWId != undefined && filterMpkMpkw.listMPKMPKWId?.length > 0) {
        filterMpkMpkw.listMPKMPKWId.forEach(id => {
            param.append('listMPKMPKWId', id);
        });
    }

    if (filterMpkMpkw.listProvinsiKode != undefined && filterMpkMpkw.listProvinsiKode?.length > 0) {
        filterMpkMpkw.listProvinsiKode.forEach(id => {
            param.append('ListProvinsiKode', id);
        });
    }

    if (filterMpkMpkw.listKabupatenKotaKode != undefined && filterMpkMpkw.listKabupatenKotaKode?.length > 0) {
        filterMpkMpkw.listKabupatenKotaKode.forEach(id => {
            param.append('ListKabupatenKotaKode', id);
        });
    }

    if (filterMpkMpkw.sortField !== undefined) {
        param.append("sortField", filterMpkMpkw.sortField.toString());
    }
    if (filterMpkMpkw.sortOrder !== undefined) {
        param.append("sortOrder", filterMpkMpkw.sortOrder.toString());
    }
    if (filterMpkMpkw.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterMpkMpkw.itemsPerPage.toString());
    }
    if (filterMpkMpkw.page !== undefined) {
        param.append("page", filterMpkMpkw.page.toString());
    }

    return BackendApiUrl.mpkmpkw.getMpkMpkwPaginate + "?" + param.toString();
}

export function ExportExcelMpkMpkw(
    filterMpkMpkw: FilterMpkMpkw
) {
    const param = new URLSearchParams();
    if (filterMpkMpkw.listMPKMPKWId != undefined && filterMpkMpkw.listMPKMPKWId?.length > 0) {
        filterMpkMpkw.listMPKMPKWId.forEach(id => {
            param.append('listMPKMPKWId', id);
        });
    }

    if (filterMpkMpkw.listProvinsiKode != undefined && filterMpkMpkw.listProvinsiKode?.length > 0) {
        filterMpkMpkw.listProvinsiKode.forEach(id => {
            param.append('ListProvinsiKode', id);
        });
    }


    if (filterMpkMpkw.listKabupatenKotaKode != undefined && filterMpkMpkw.listKabupatenKotaKode?.length > 0) {
        filterMpkMpkw.listKabupatenKotaKode.forEach(id => {
            param.append('ListKabupatenKotaKode', id);
        });
    }

    if (filterMpkMpkw.sortField !== undefined) {
        param.append("sortField", filterMpkMpkw.sortField.toString());
    }
    if (filterMpkMpkw.sortOrder !== undefined) {
        param.append("sortOrder", filterMpkMpkw.sortOrder.toString());
    }

    return BackendApiUrl.mpkmpkw.exportExcelMpkMpkw + "?" + param.toString();
}

export function GetPengurusList(
    filterPengurus: FilterPengurus
) {
    const param = new URLSearchParams();
    if (filterPengurus.nik !== undefined) {
        param.append("nik", filterPengurus.nik.toString());
    }
    if (filterPengurus.namaDepan !== undefined) {
        param.append("namaDepan", filterPengurus.namaDepan.toString());
    }
    if (filterPengurus.namaTengah !== undefined) {
        param.append("namaTengah", filterPengurus.namaTengah.toString());
    }
    if (filterPengurus.namaBelakang !== undefined) {
        param.append("namaBelakang", filterPengurus.namaBelakang.toString());
    }

    if (filterPengurus.listTipe != undefined && filterPengurus.listTipe?.length > 0) {
        filterPengurus.listTipe.forEach(id => {
            param.append('listTipe', id);
        });
    }

    if (filterPengurus.listProvinsiKode != undefined && filterPengurus.listProvinsiKode?.length > 0) {
        filterPengurus.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }

    if (filterPengurus.listKabupatenKotaKode != undefined && filterPengurus.listKabupatenKotaKode?.length > 0) {
        filterPengurus.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }

    if (filterPengurus.sortField !== undefined) {
        param.append("sortField", filterPengurus.sortField.toString());
    }
    if (filterPengurus.sortOrder !== undefined) {
        param.append("sortOrder", filterPengurus.sortOrder.toString());
    }
    if (filterPengurus.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterPengurus.itemsPerPage.toString());
    }
    if (filterPengurus.page !== undefined) {
        param.append("page", filterPengurus.page.toString());
    }

    return BackendApiUrl.pengurus.getPengurusPaginate + "?" + param.toString();
}

export function ExportExcelPengurus(
    filterPengurus: FilterPengurus
) {
    const param = new URLSearchParams();
    if (filterPengurus.nik !== undefined) {
        param.append("nik", filterPengurus.nik.toString());
    }
    if (filterPengurus.namaDepan !== undefined) {
        param.append("namaDepan", filterPengurus.namaDepan.toString());
    }
    if (filterPengurus.namaTengah !== undefined) {
        param.append("namaTengah", filterPengurus.namaTengah.toString());
    }
    if (filterPengurus.namaBelakang !== undefined) {
        param.append("namaBelakang", filterPengurus.namaBelakang.toString());
    }

    if (filterPengurus.listTipe != undefined && filterPengurus.listTipe?.length > 0) {
        filterPengurus.listTipe.forEach(id => {
            param.append('listTipe', id);
        });
    }

    if (filterPengurus.listProvinsiKode != undefined && filterPengurus.listProvinsiKode?.length > 0) {
        filterPengurus.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }

    if (filterPengurus.listKabupatenKotaKode != undefined && filterPengurus.listKabupatenKotaKode?.length > 0) {
        filterPengurus.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }

    if (filterPengurus.sortField !== undefined) {
        param.append("sortField", filterPengurus.sortField.toString());
    }
    if (filterPengurus.sortOrder !== undefined) {
        param.append("sortOrder", filterPengurus.sortOrder.toString());
    }

    return BackendApiUrl.pengurus.exportExcelPengurus + "?" + param.toString();
}

export function GetStrukturOrganisasiList(
    filterStrukturOrganisasi: FilterStrukturOrganisasi
) {
    const param = new URLSearchParams();

    if (filterStrukturOrganisasi.listId != undefined && filterStrukturOrganisasi.listId?.length > 0) {
        filterStrukturOrganisasi.listId.forEach(id => {
            param.append('listId', id);
        });
    }

    if (filterStrukturOrganisasi.listStatusAktif != undefined && filterStrukturOrganisasi.listStatusAktif?.length > 0) {
        filterStrukturOrganisasi.listStatusAktif.forEach(id => {
            param.append('listStatusAktif', id);
        });
    }

    if (filterStrukturOrganisasi.sortField !== undefined) {
        param.append("sortField", filterStrukturOrganisasi.sortField.toString());
    }
    if (filterStrukturOrganisasi.sortOrder !== undefined) {
        param.append("sortOrder", filterStrukturOrganisasi.sortOrder.toString());
    }
    if (filterStrukturOrganisasi.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterStrukturOrganisasi.itemsPerPage.toString());
    }
    if (filterStrukturOrganisasi.page !== undefined) {
        param.append("page", filterStrukturOrganisasi.page.toString());
    }

    return BackendApiUrl.strukturOrganisasi.getStrukturOrganisasiPaginate + "?" + param.toString();
}

export function ExportExcelStrukturOrganisasi(
    filterStrukturOrganisasi: FilterStrukturOrganisasi
) {
    const param = new URLSearchParams();

    if (filterStrukturOrganisasi.listId != undefined && filterStrukturOrganisasi.listId?.length > 0) {
        filterStrukturOrganisasi.listId.forEach(id => {
            param.append('listId', id);
        });
    }

    if (filterStrukturOrganisasi.listStatusAktif != undefined && filterStrukturOrganisasi.listStatusAktif?.length > 0) {
        filterStrukturOrganisasi.listStatusAktif.forEach(id => {
            param.append('listStatusAktif', id);
        });
    }

    if (filterStrukturOrganisasi.sortField !== undefined) {
        param.append("sortField", filterStrukturOrganisasi.sortField.toString());
    }
    if (filterStrukturOrganisasi.sortOrder !== undefined) {
        param.append("sortOrder", filterStrukturOrganisasi.sortOrder.toString());
    }

    return BackendApiUrl.strukturOrganisasi.exportExcelStrukturOrganisasi + "?" + param.toString();
}

export function GetKomisiList(
    filterKomisi: FilterKomisi
) {
    const param = new URLSearchParams();

    if (filterKomisi.listId != undefined && filterKomisi.listId?.length > 0) {
        filterKomisi.listId.forEach(id => {
            param.append('listId', id);
        });
    }

    if (filterKomisi.listStatusAktif != undefined && filterKomisi.listStatusAktif?.length > 0) {
        filterKomisi.listStatusAktif.forEach(id => {
            param.append('listStatusAktif', id);
        });
    }

    if (filterKomisi.sortField !== undefined) {
        param.append("sortField", filterKomisi.sortField.toString());
    }
    if (filterKomisi.sortOrder !== undefined) {
        param.append("sortOrder", filterKomisi.sortOrder.toString());
    }
    if (filterKomisi.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterKomisi.itemsPerPage.toString());
    }
    if (filterKomisi.page !== undefined) {
        param.append("page", filterKomisi.page.toString());
    }

    return BackendApiUrl.komisi.getKomisiPaginate + "?" + param.toString();
}

export function ExportExcelKomisi(
    filterKomisi: FilterKomisi
) {
    const param = new URLSearchParams();

    if (filterKomisi.listId != undefined && filterKomisi.listId?.length > 0) {
        filterKomisi.listId.forEach(id => {
            param.append('listId', id);
        });
    }

    if (filterKomisi.listStatusAktif != undefined && filterKomisi.listStatusAktif?.length > 0) {
        filterKomisi.listStatusAktif.forEach(id => {
            param.append('listStatusAktif', id);
        });
    }

    if (filterKomisi.sortField !== undefined) {
        param.append("sortField", filterKomisi.sortField.toString());
    }
    if (filterKomisi.sortOrder !== undefined) {
        param.append("sortOrder", filterKomisi.sortOrder.toString());
    }

    return BackendApiUrl.komisi.exportExcelKomisi + "?" + param.toString();
}

export function GetTaskForceList(
    filterTaskForce: FilterTaskForce
) {
    const param = new URLSearchParams();

    if (filterTaskForce.listId != undefined && filterTaskForce.listId?.length > 0) {
        filterTaskForce.listId.forEach(id => {
            param.append('listId', id);
        });
    }

    if (filterTaskForce.listStatusAktif != undefined && filterTaskForce.listStatusAktif?.length > 0) {
        filterTaskForce.listStatusAktif.forEach(id => {
            param.append('listStatusAktif', id);
        });
    }

    if (filterTaskForce.sortField !== undefined) {
        param.append("sortField", filterTaskForce.sortField.toString());
    }
    if (filterTaskForce.sortOrder !== undefined) {
        param.append("sortOrder", filterTaskForce.sortOrder.toString());
    }
    if (filterTaskForce.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterTaskForce.itemsPerPage.toString());
    }
    if (filterTaskForce.page !== undefined) {
        param.append("page", filterTaskForce.page.toString());
    }

    return BackendApiUrl.taskForce.getTaskForcePaginate + "?" + param.toString();
}

export function ExportExcelTaskForce(
    filterTaskForce: FilterTaskForce
) {
    const param = new URLSearchParams();

    if (filterTaskForce.listId != undefined && filterTaskForce.listId?.length > 0) {
        filterTaskForce.listId.forEach(id => {
            param.append('listId', id);
        });
    }

    if (filterTaskForce.listStatusAktif != undefined && filterTaskForce.listStatusAktif?.length > 0) {
        filterTaskForce.listStatusAktif.forEach(id => {
            param.append('listStatusAktif', id);
        });
    }

    if (filterTaskForce.sortField !== undefined) {
        param.append("sortField", filterTaskForce.sortField.toString());
    }
    if (filterTaskForce.sortOrder !== undefined) {
        param.append("sortOrder", filterTaskForce.sortOrder.toString());
    }

    return BackendApiUrl.taskForce.exportExcelTaskForce + "?" + param.toString();
}


export function GetProgramKerjaList(
    filterProgramKerja: FilterProgramKerja
) {
    const param = new URLSearchParams();
    if (filterProgramKerja.nama !== undefined) {
        param.append("nama", filterProgramKerja.nama.toString());
    }
    if (filterProgramKerja.listStrukturOrganisasiId != undefined && filterProgramKerja.listStrukturOrganisasiId.length > 0) {
        filterProgramKerja.listStrukturOrganisasiId.forEach(id => {
            param.append('listStrukturOrganisasiId', id);
        });
    }
    if (filterProgramKerja.listKomisiId != undefined && filterProgramKerja.listKomisiId.length > 0) {
        filterProgramKerja.listKomisiId.forEach(id => {
            param.append('listKomisiId', id);
        });
    }
    if (filterProgramKerja.listMisiProgramKerjaId != undefined && filterProgramKerja.listMisiProgramKerjaId.length > 0) {
        filterProgramKerja.listMisiProgramKerjaId.forEach(id => {
            param.append('listMisiProgramKerjaId', id);
        })
    }
    if (filterProgramKerja.tanggalMulai !== undefined && filterProgramKerja.tanggalMulai !== null) {
        param.append("tanggalMulai", dayjs(filterProgramKerja.tanggalMulai).format("YYYY-MM-DD"));
    }
    if (filterProgramKerja.tanggalAkhir !== undefined && filterProgramKerja.tanggalAkhir !== null) {
        param.append("tanggalAkhir", dayjs(filterProgramKerja.tanggalAkhir).format("YYYY-MM-DD"));
    }
    if (filterProgramKerja.sortField !== undefined) {
        param.append("sortField", filterProgramKerja.sortField.toString());
    }
    if (filterProgramKerja.sortOrder !== undefined) {
        param.append("sortOrder", filterProgramKerja.sortOrder.toString());
    }
    if (filterProgramKerja.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterProgramKerja.itemsPerPage.toString());
    }
    if (filterProgramKerja.page !== undefined) {
        param.append("page", filterProgramKerja.page.toString());
    }

    return BackendApiUrl.programKerja.getProgramKerjaPaginate + "?" + param.toString();
}

export function ExportExcelProgramKerja(
    filterProgramKerja: FilterProgramKerja
) {
    const param = new URLSearchParams();
    if (filterProgramKerja.nama !== undefined) {
        param.append("nama", filterProgramKerja.nama.toString());
    }
    if (filterProgramKerja.listStrukturOrganisasiId != undefined && filterProgramKerja.listStrukturOrganisasiId.length > 0) {
        filterProgramKerja.listStrukturOrganisasiId.forEach(id => {
            param.append('listStrukturOrganisasiId', id);
        });
    }
    if (filterProgramKerja.listKomisiId != undefined && filterProgramKerja.listKomisiId.length > 0) {
        filterProgramKerja.listKomisiId.forEach(id => {
            param.append('listKomisiId', id);
        });
    }
    if (filterProgramKerja.listMisiProgramKerjaId != undefined && filterProgramKerja.listMisiProgramKerjaId.length > 0) {
        filterProgramKerja.listMisiProgramKerjaId.forEach(id => {
            param.append('listMisiProgramKerjaId', id);
        })
    }
    if (filterProgramKerja.tanggalMulai !== undefined && filterProgramKerja.tanggalMulai !== null) {
        param.append("tanggalMulai", dayjs(filterProgramKerja.tanggalMulai).format("YYYY-MM-DD"));
    }
    if (filterProgramKerja.tanggalAkhir !== undefined && filterProgramKerja.tanggalAkhir !== null) {
        param.append("tanggalAkhir", dayjs(filterProgramKerja.tanggalAkhir).format("YYYY-MM-DD"));
    }
    if (filterProgramKerja.sortField !== undefined) {
        param.append("sortField", filterProgramKerja.sortField.toString());
    }
    if (filterProgramKerja.sortOrder !== undefined) {
        param.append("sortOrder", filterProgramKerja.sortOrder.toString());
    }

    return BackendApiUrl.programKerja.exportExcelProgramKerja + "?" + param.toString();
}

export function GetTrainerList(filterTrainer: FilterTrainerPage) {
    const param = new URLSearchParams();

    if (filterTrainer.namaDepan !== undefined) {
        param.append("namaDepan", filterTrainer.namaDepan.toString());
    }
    if (filterTrainer.namaTengah !== undefined) {
        param.append("namaTengah", filterTrainer.namaTengah.toString());
    }
    if (filterTrainer.namaBelakang !== undefined) {
        param.append("namaBelakang", filterTrainer.namaBelakang.toString());
    }
    if (filterTrainer.sekolahId !== undefined) {
        param.append("sekolahId", filterTrainer.sekolahId.toString());
    }
    if (filterTrainer.listProvinsiKode != undefined && filterTrainer.listProvinsiKode?.length > 0) {
        filterTrainer.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }
    if (filterTrainer.listKabupatenKotaKode != undefined && filterTrainer.listKabupatenKotaKode?.length > 0) {
        filterTrainer.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }
    if (filterTrainer.sortField !== undefined) {
        param.append("sortField", filterTrainer.sortField.toString());
    }
    if (filterTrainer.sortOrder !== undefined) {
        param.append("sortOrder", filterTrainer.sortOrder.toString());
    }
    if (filterTrainer.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterTrainer.itemsPerPage.toString());
    }
    if (filterTrainer.page !== undefined) {
        param.append("page", filterTrainer.page.toString());
    }

    return BackendApiUrl.trainer.getTrainerPaginate + "?" + param.toString();
}

export function ExportExcelTrainer(filterTrainer: FilterTrainerPage) {
    const param = new URLSearchParams();

    if (filterTrainer.namaDepan !== undefined) {
        param.append("namaDepan", filterTrainer.namaDepan.toString());
    }
    if (filterTrainer.namaTengah !== undefined) {
        param.append("namaTengah", filterTrainer.namaTengah.toString());
    }
    if (filterTrainer.namaBelakang !== undefined) {
        param.append("namaBelakang", filterTrainer.namaBelakang.toString());
    }
    if (filterTrainer.sekolahId !== undefined) {
        param.append("sekolahId", filterTrainer.sekolahId.toString());
    }
    if (filterTrainer.listProvinsiKode != undefined && filterTrainer.listProvinsiKode?.length > 0) {
        filterTrainer.listProvinsiKode.forEach(id => {
            param.append('listProvinsiKode', id);
        });
    }
    if (filterTrainer.listKabupatenKotaKode != undefined && filterTrainer.listKabupatenKotaKode?.length > 0) {
        filterTrainer.listKabupatenKotaKode.forEach(id => {
            param.append('listKabupatenKotaKode', id);
        });
    }
    if (filterTrainer.sortField !== undefined) {
        param.append("sortField", filterTrainer.sortField.toString());
    }
    if (filterTrainer.sortOrder !== undefined) {
        param.append("sortOrder", filterTrainer.sortOrder.toString());
    }
    if (filterTrainer.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterTrainer.itemsPerPage.toString());
    }
    if (filterTrainer.page !== undefined) {
        param.append("page", filterTrainer.page.toString());
    }

    return BackendApiUrl.trainer.exportExcelTrainer + "?" + param.toString();
}

export function GetManajemenRoleList(filterManajemenRole: FilterManajemenRolePage) {
    const param = new URLSearchParams();

    if (filterManajemenRole.nama !== undefined) {
        param.append("Nama", filterManajemenRole.nama.toString());
    }
    if (filterManajemenRole.sortField !== undefined) {
        param.append("SortField", filterManajemenRole.sortField.toString());
    }
    if (filterManajemenRole.sortOrder !== undefined) {
        param.append("SortOrder", filterManajemenRole.sortOrder.toString());
    }
    if (filterManajemenRole.itemsPerPage !== undefined) {
        param.append("ItemsPerPage", filterManajemenRole.itemsPerPage.toString());
    }
    if (filterManajemenRole.page !== undefined) {
        param.append("Page", filterManajemenRole.page.toString());
    }

    return BackendApiUrl.manajemenRole.getManajemenRolePaginate + "?" + param.toString();
}

export function GetRolePermissionList(filterRolePermission: FilterRolePermissionPage) {
    const param = new URLSearchParams();

    if (filterRolePermission.hakAkses !== undefined) {
        param.append("HakAkses", filterRolePermission.hakAkses.toString());
    }

    return BackendApiUrl.manajemenRole.getRolePermissionPaginate + "?" + param.toString();
}

export function GetRoleList(filterRole: FilterRoleList) {
    const param = new URLSearchParams();

    if (filterRole.nama !== undefined) {
        param.append("Nama", filterRole.nama.toString());
    }

    return BackendApiUrl.manajemenRole.getListRole + "?" + param.toString();
}

export function GetMitraList(filterMitra: FilterMitra) {
    const param = new URLSearchParams();

    if (filterMitra.nama !== undefined && filterMitra.nama !== null) {
        param.append("namaMitra", filterMitra.nama.toString());
    }

    if (filterMitra.tipeMitraId !== undefined && filterMitra.tipeMitraId !== null) {
        param.append("tipeMitraId", filterMitra.tipeMitraId.toString());
    }

    if (filterMitra.provinsiKode !== undefined && filterMitra.provinsiKode !== null) {
        param.append("provinsiKode", filterMitra.provinsiKode.toString());
    }

    if (filterMitra.kabupatenKotaKode !== undefined && filterMitra.kabupatenKotaKode !== null) {
        param.append("kabupatenKotaKode", filterMitra.kabupatenKotaKode.toString());
    }

    if (filterMitra.sortField !== undefined) {
        param.append("sortField", filterMitra.sortField.toString());
    }

    if (filterMitra.sortOrder !== undefined) {
        param.append("sortOrder", filterMitra.sortOrder.toString());
    }

    if (filterMitra.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterMitra.itemsPerPage.toString());
    }

    if (filterMitra.page !== undefined) {
        param.append("page", filterMitra.page.toString());
    }

    return BackendApiUrl.mitra.getMitraPaginate + "?" + param.toString();
}

export function ExportExcelMitra(filterMitra: FilterMitra) {
    const param = new URLSearchParams();

    if (filterMitra.nama !== undefined && filterMitra.nama !== null) {
        param.append("namaMitra", filterMitra.nama.toString());
    }

    if (filterMitra.tipeMitraId !== undefined && filterMitra.tipeMitraId !== null) {
        param.append("tipeMitraId", filterMitra.tipeMitraId.toString());
    }

    if (filterMitra.provinsiKode !== undefined && filterMitra.provinsiKode !== null) {
        param.append("provinsiKode", filterMitra.provinsiKode.toString());
    }

    if (filterMitra.kabupatenKotaKode !== undefined && filterMitra.kabupatenKotaKode !== null) {
        param.append("kabupatenKotaKode", filterMitra.kabupatenKotaKode.toString());
    }

    if (filterMitra.sortField !== undefined) {
        param.append("sortField", filterMitra.sortField.toString());
    }

    if (filterMitra.sortOrder !== undefined) {
        param.append("sortOrder", filterMitra.sortOrder.toString());
    }

    return BackendApiUrl.mitra.exportExcelMitra + "?" + param.toString();
}

export function GetLowonganPekerjaanList(
    filterLowonganPekerjaan: FilterLowonganPekerjaan,
) {
    const param = new URLSearchParams();
    if (filterLowonganPekerjaan.nama !== undefined) {
        param.append("nama", filterLowonganPekerjaan.nama.toString());
    }
    if (filterLowonganPekerjaan.tipeLowonganPekerjaanId !== undefined) {
        param.append("tipeLowonganPekerjaanId", filterLowonganPekerjaan.tipeLowonganPekerjaanId.toString());
    }
    if (filterLowonganPekerjaan.mataPelajaran !== undefined) {
        param.append("mataPelajaran", filterLowonganPekerjaan.mataPelajaran.toString());
    }
    if (filterLowonganPekerjaan.tanggalAkhirDaftar !== undefined && filterLowonganPekerjaan.tanggalAkhirDaftar !== null) {
        param.append("tanggalAkhirDaftar", dayjs(filterLowonganPekerjaan.tanggalAkhirDaftar).format("YYYY-MM-DD"));
    }

    if (filterLowonganPekerjaan.sortField !== undefined) {
        param.append("sortField", filterLowonganPekerjaan.sortField.toString());
    }
    if (filterLowonganPekerjaan.sortOrder !== undefined) {
        param.append("sortOrder", filterLowonganPekerjaan.sortOrder.toString());
    }
    if (filterLowonganPekerjaan.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filterLowonganPekerjaan.itemsPerPage.toString());
    }
    if (filterLowonganPekerjaan.page !== undefined) {
        param.append("page", filterLowonganPekerjaan.page.toString());
    }

    return BackendApiUrl.lowonganPekerjaan.getLowonganPekerjaanPaginate + "?" + param.toString();
}

export function ExportExcelLowonganPekerjaan(
    filterLowonganPekerjaan: FilterLowonganPekerjaan,
) {
    const param = new URLSearchParams();
    if (filterLowonganPekerjaan.nama !== undefined && filterLowonganPekerjaan.nama !== "") {
        param.append("nama", filterLowonganPekerjaan.nama.toString());
    }
    if (filterLowonganPekerjaan.tipeLowonganPekerjaanId !== undefined && filterLowonganPekerjaan.tipeLowonganPekerjaanId !== "") {
        param.append("tipeLowonganPekerjaanId", filterLowonganPekerjaan.tipeLowonganPekerjaanId.toString());
    }
    if (filterLowonganPekerjaan.mataPelajaran !== undefined && filterLowonganPekerjaan.mataPelajaran !== "") {
        param.append("mataPelajaran", filterLowonganPekerjaan.mataPelajaran.toString());
    }
    if (filterLowonganPekerjaan.tanggalAkhirDaftar !== undefined && filterLowonganPekerjaan.tanggalAkhirDaftar !== null) {
        param.append("tanggalAkhirDaftar", dayjs(filterLowonganPekerjaan.tanggalAkhirDaftar).toISOString());
    }

    if (filterLowonganPekerjaan.sortField !== undefined) {
        param.append("sortField", filterLowonganPekerjaan.sortField.toString());
    }
    if (filterLowonganPekerjaan.sortOrder !== undefined) {
        param.append("sortOrder", filterLowonganPekerjaan.sortOrder.toString());
    }

    return BackendApiUrl.lowonganPekerjaan.exportExcelLowonganPekerjaan + "?" + param.toString();
}

export function GetManajemenFkipFilterOptions(selectedProvinsiCode?: string, selectedKabupatenKotaCode?: string, selectedKecamatanCode?: string) {
    const param = new URLSearchParams();

    if (selectedProvinsiCode !== undefined) {
        param.append("selectedProvinsiCode", selectedProvinsiCode.toString());
    }

    if (selectedKabupatenKotaCode !== undefined) {
        param.append("selectedKabupatenKotaCode", selectedKabupatenKotaCode.toString());
    }

    if (selectedKecamatanCode !== undefined) {
        param.append("selectedKecamatanCode", selectedKecamatanCode.toString());
    }

    return BackendApiUrl.manajemenAlumniFkip.getManajemenFkipFilterOptions + "?" + param.toString();
}

export function GetManajemenAlumniFkipList(filterValues: ManajemenAlumniFkipFilterForm) {
    const param = new URLSearchParams();
    if (filterValues.page !== undefined) {
        param.append("page", filterValues.page.toString());
    }
    if (filterValues.pageSize !== undefined) {
        param.append("pageSize", filterValues.pageSize.toString());
    }
    if (filterValues.name !== undefined) {
        param.append("nama", filterValues.name.toString());
    }
    if (filterValues.nim !== undefined) {
        param.append("nim", filterValues.nim.toString());
    }
    if (filterValues.tahunLulus !== undefined) {
        param.append("angkatanKelulusan", filterValues.tahunLulus.toString());
    }
    if (filterValues.province !== undefined) {
        param.append("provinsiCode", filterValues.province.toString());
    }
    if (filterValues.city !== undefined) {
        param.append("kabupatenKotaCode", filterValues.city.toString());
    }
    if (filterValues.subdistrict !== undefined) {
        param.append("kecamatanCode", filterValues.subdistrict.toString());
    }
    if (filterValues.statusKerja !== undefined) {
        param.append("statusPekerjaan", filterValues.statusKerja.toString());
    }
    if (filterValues.sortField !== undefined) {
        param.append("sortField", filterValues.sortField.toString());
    }
    if (filterValues.sortOrder !== undefined) {
        param.append("sortOrder", filterValues.sortOrder.toString());
    }
    return BackendApiUrl.manajemenAlumniFkip.getManajemenAlumniFkipList + "?" + param.toString();
}

export function GetManajemenAlumniFkipExcelData(filterValues: ManajemenAlumniFkipFilterForm) {
    const param = new URLSearchParams();
    if (filterValues.name !== undefined) {
        param.append("nama", filterValues.name.toString());
    }
    if (filterValues.nim !== undefined) {
        param.append("nim", filterValues.nim.toString());
    }
    if (filterValues.tahunLulus !== undefined) {
        param.append("angkatanKelulusan", filterValues.tahunLulus.toString());
    }
    if (filterValues.province !== undefined) {
        param.append("provinsiCode", filterValues.province.toString());
    }
    if (filterValues.city !== undefined) {
        param.append("kabupatenKotaCode", filterValues.city.toString());
    }
    if (filterValues.subdistrict !== undefined) {
        param.append("kecamatanCode", filterValues.subdistrict.toString());
    }
    if (filterValues.statusKerja !== undefined) {
        param.append("statusPekerjaan", filterValues.statusKerja.toString());
    }
    return BackendApiUrl.manajemenAlumniFkip.getAlumniFkipExcelData + "?" + param.toString();
}

// Pelamar Pekerjaan Helper Functions
export function GetPelamarPekerjaanList(
    filter: FilterPelamarPekerjaan
) {
    const param = new URLSearchParams();

    if (filter.namaPelamar !== undefined && filter.namaPelamar !== "") {
        param.append("nama", filter.namaPelamar.toString());
    }
    if (filter.namaLowongan !== undefined && filter.namaLowongan !== "") {
        param.append("namaLowongan", filter.namaLowongan.toString());
    }
    if (filter.status !== undefined && filter.status !== "") {
        param.append("statusId", filter.status.toString());
    }
    if (filter.sortField !== undefined) {
        param.append("sortField", filter.sortField.toString());
    }
    if (filter.sortOrder !== undefined) {
        param.append("sortOrder", filter.sortOrder.toString());
    }
    if (filter.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filter.itemsPerPage.toString());
    }
    if (filter.page !== undefined) {
        param.append("page", filter.page.toString());
    }

    return BackendApiUrl.pelamarPekerjaan.getPelamarPekerjaanPaginate + "?" + param.toString();
}

export function ExportExcelPelamarPekerjaan(
    filter: FilterPelamarPekerjaan
) {
    const param = new URLSearchParams();

    if (filter.namaPelamar !== undefined && filter.namaPelamar !== "") {
        param.append("namapelamar", filter.namaPelamar.toString());
    }
    if (filter.namaLowongan !== undefined && filter.namaLowongan !== "") {
        param.append("namaLowongan", filter.namaLowongan.toString());
    }
    if (filter.status !== undefined && filter.status !== "") {
        param.append("statusId", filter.status.toString());
    }
    if (filter.sortField !== undefined) {
        param.append("sortField", filter.sortField.toString());
    }
    if (filter.sortOrder !== undefined) {
        param.append("sortOrder", filter.sortOrder.toString());
    }

    return BackendApiUrl.pelamarPekerjaan.exportExcelPelamarPekerjaan + "?" + param.toString();
}

// Beasiswa Helper Functions
export function GetBeasiswaList(
    filter: FilterBeasiswa,
) {
    const param = new URLSearchParams();
    if (filter.nama !== undefined && filter.nama !== "") {
        param.append("nama", filter.nama.toString());
    }
    if (filter.jenisBeasiswaId !== undefined && filter.jenisBeasiswaId !== "") {
        param.append("jenisBeasiswaId", filter.jenisBeasiswaId.toString());
    }
    if (filter.status !== undefined && filter.status !== "") {
        param.append("isAktif", filter.status == "1" ? "true" : "false");
    }
    if (filter.tanggalAwalDaftar !== undefined && filter.tanggalAwalDaftar !== null) {
        param.append("tanggalAwalDaftar", dayjs(filter.tanggalAwalDaftar).format("YYYY-MM-DD"));
    }
    if (filter.tanggalAkhirDaftar !== undefined && filter.tanggalAkhirDaftar !== null) {
        param.append("tanggalAkhirDaftar", dayjs(filter.tanggalAkhirDaftar).format("YYYY-MM-DD"));
    }
    if (filter.sortField !== undefined) {
        param.append("sortField", filter.sortField.toString());
    }
    if (filter.sortOrder !== undefined) {
        param.append("sortOrder", filter.sortOrder.toString());
    }
    if (filter.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filter.itemsPerPage.toString());
    }
    if (filter.page !== undefined) {
        param.append("page", filter.page.toString());
    }
    if (filter.kategoriPemberiBeasiswaId !== undefined && filter.kategoriPemberiBeasiswaId !== "") {
        param.append("kategoriPemberiBeasiswaId", filter.kategoriPemberiBeasiswaId.toString());
    }

    return BackendApiUrl.beasiswa.list + "?" + param.toString();
}

export function ExportExcelBeasiswa(
    filter: FilterBeasiswa,
) {
    const param = new URLSearchParams();
    if (filter.nama !== undefined && filter.nama !== "") {
        param.append("nama", filter.nama.toString());
    }
    if (filter.jenisBeasiswaId !== undefined && filter.jenisBeasiswaId !== "") {
        param.append("jenisBeasiswaId", filter.jenisBeasiswaId.toString());
    }
    if (filter.status !== undefined && filter.status !== "") {
        param.append("isAktif", filter.status == "1" ? "true" : "false");
    }
    if (filter.tanggalAwalDaftar !== undefined && filter.tanggalAwalDaftar !== null) {
        param.append("tanggalAwalDaftar", dayjs(filter.tanggalAwalDaftar).toISOString());
    }
    if (filter.tanggalAkhirDaftar !== undefined && filter.tanggalAkhirDaftar !== null) {
        param.append("tanggalAkhirDaftar", dayjs(filter.tanggalAkhirDaftar).toISOString());
    }
    if (filter.sortField !== undefined) {
        param.append("sortField", filter.sortField.toString());
    }
    if (filter.sortOrder !== undefined) {
        param.append("sortOrder", filter.sortOrder.toString());
    }
    if (filter.kategoriPemberiBeasiswaId !== undefined && filter.kategoriPemberiBeasiswaId !== "") {
        param.append("kategoriPemberiBeasiswaId", filter.kategoriPemberiBeasiswaId.toString());
    }

    return BackendApiUrl.beasiswa.exportExcel + "?" + param.toString();
}

// Pelamar Pekerjaan Helper Functions
export function GetMetabaseReportsList(
    filter: FilterLaporan,
) {
    const param = new URLSearchParams();
    if (filter.name !== undefined && filter.name !== "") {
        param.append("Name", filter.name.toString());
    }
    if (filter.sortField !== undefined) {
        param.append("sortField", filter.sortField.toString());
    }
    if (filter.sortOrder !== undefined) {
        param.append("sortOrder", filter.sortOrder.toString());
    }
    if (filter.itemsPerPage !== undefined) {
        param.append("itemsPerPage", filter.itemsPerPage.toString());
    }
    if (filter.page !== undefined) {
        param.append("page", filter.page.toString());
    }

    return BackendApiUrl.metabaseReports.getMetabaseReports + "?" + param.toString();
}
// Laporan Functions
export function GetMetabaseReportById(
    id: string,
) {
    return BackendApiUrl.metabaseReports.getMetabaseReportById + "/" + encodeURI(id);
}

export function ValidateMetabaseReport(params: {
    name?: string;
    embededLink?: string;
    excludeId?: string;
}) {
    const query = new URLSearchParams();

    if (params.name !== undefined) {
        query.append("name", params.name);
    }

    if (params.embededLink !== undefined) {
        query.append("embededLink", params.embededLink);
    }

    if (params.excludeId !== undefined) {
        query.append("excludeId", params.excludeId);
    }

    return BackendApiUrl.metabaseReports.validateMetabaseReport + "?" + query.toString();
}

// Laporan Functions
export function GetReportEmbedUrl(
    id: string,
) {
    return BackendApiUrl.reporting.getReportEmbedUrl + "/" + encodeURI(id);
}

// Public Roles Functions
export function GetRoles(
    filter: FilterRoleList,
) {
    const param = new URLSearchParams();
    if (filter.nama !== undefined) {
        param.append("nama", filter.nama.toString());
    }

    return BackendApiUrl.roles.getRoles + "?" + param.toString();
}

export function GetManajemenCalonGuruFilterOptions(selectedProvinsiCode?: string, selectedKabupatenKotaCode?: string, selectedKecamatanCode?: string) {
    const param = new URLSearchParams();

    if (selectedProvinsiCode !== undefined) {
        param.append("selectedProvinsiCode", selectedProvinsiCode.toString());
    }

    if (selectedKabupatenKotaCode !== undefined) {
        param.append("selectedKabupatenKotaCode", selectedKabupatenKotaCode.toString());
    }

    if (selectedKecamatanCode !== undefined) {
        param.append("selectedKecamatanCode", selectedKecamatanCode.toString());
    }

    return BackendApiUrl.manajemenCalonGuru.getManajemenCalonGuruFilterOptions + "?" + param.toString();
}

export function GetManajemenCalonGuruList(filterValues: GetManajemenCalonGuruListRequest) {
    const param = new URLSearchParams();
    if (filterValues.page !== undefined) {
        param.append("page", filterValues.page.toString());
    }
    if (filterValues.pageSize !== undefined) {
        param.append("pageSize", filterValues.pageSize.toString());
    }
    if (filterValues.namaDepan !== undefined) {
        param.append("namaDepan", filterValues.namaDepan.toString());
    }
    if (filterValues.namaBelakang !== undefined) {
        param.append("namaBelakang", filterValues.namaBelakang.toString());
    }
    if (filterValues.namaTengah !== undefined) {
        param.append("namaTengah", filterValues.namaTengah.toString());
    }
    if (filterValues.agama !== undefined) {
        param.append("agama", filterValues.agama.toString());
    }
    if (filterValues.lulusanFkip !== undefined) {
        param.append("lulusanFKIP", filterValues.lulusanFkip.toString());
    }
    if (filterValues.jenisKelamin !== undefined) {
        param.append("jenisKelamin", filterValues.jenisKelamin.toString());
    }
    if (filterValues.provinsi !== undefined) {
        param.append("provinsi", filterValues.provinsi.toString());
    }
    if (filterValues.kabupatenKota !== undefined) {
        param.append("kabupatenKota", filterValues.kabupatenKota.toString());
    }
    if (filterValues.sortField !== undefined) {
        param.append("sortField", filterValues.sortField.toString());
    }
    if (filterValues.sortOrder !== undefined) {
        param.append("sortOrder", filterValues.sortOrder.toString());
    }
    return BackendApiUrl.manajemenCalonGuru.getManajemenCalonGuruList + "?" + param.toString();
}

export function GetManajemenCalonGuruExcelData(filterValues: GetManajemenCalonGuruListRequest) {
    const param = new URLSearchParams();
    if (filterValues.namaDepan !== undefined) {
        param.append("namaDepan", filterValues.namaDepan.toString());
    }
    if (filterValues.namaBelakang !== undefined) {
        param.append("namaBelakang", filterValues.namaBelakang.toString());
    }
    if (filterValues.namaTengah !== undefined) {
        param.append("namaTengah", filterValues.namaTengah.toString());
    }
    if (filterValues.agama !== undefined) {
        param.append("agama", filterValues.agama.toString());
    }
    if (filterValues.lulusanFkip !== undefined) {
        param.append("lulusanFKIP", filterValues.lulusanFkip.toString());
    }
    if (filterValues.jenisKelamin !== undefined) {
        param.append("jenisKelamin", filterValues.jenisKelamin.toString());
    }
    if (filterValues.provinsi !== undefined) {
        param.append("provinsi", filterValues.provinsi.toString());
    }
    if (filterValues.kabupatenKota !== undefined) {
        param.append("kabupatenKota", filterValues.kabupatenKota.toString());
    }
    if (filterValues.sortField !== undefined) {
        param.append("sortField", filterValues.sortField.toString());
    }
    if (filterValues.sortOrder !== undefined) {
        param.append("sortOrder", filterValues.sortOrder.toString());
    }
    return BackendApiUrl.manajemenCalonGuru.getManajemenCalonGuruExcelData + "?" + param.toString();
}

// export function GetLog(itemsPerPage: number, page: number, search: string) {
//   const param = new URLSearchParams();
//   if (itemsPerPage !== undefined) {
//     param.append("itemsPerPage", itemsPerPage.toLocaleString());
//   }
//   if (page !== undefined) {
//     param.append("page", page.toLocaleString());
//   }
//   if (search !== undefined) {
//     param.append("search", search);
//   }
//   return BackendApiUrl.logUser + "?" + param.toString();
// }
